import MatchListContainer from './MatchListContainer';

export default MatchListContainer;
